export default {"src":"/_next/static/media/jaycar-logo-black.722c0c7b.svg","height":32,"width":120,"blurWidth":0,"blurHeight":0};